/* eslint-disable react/no-access-state-in-setstate */
import React from 'react';
import {
  Grid,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { Button, WithDialogsProps, withDialogs } from '@michelin/acid-components';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { WatchLater } from '@material-ui/icons';
import moment from 'moment';
import { WithTranslation, withTranslation } from '@michelin/central-provider';
import { getDates } from './Types';
import { getTimeString } from '../../Utils';
import { HoursOfOperation } from '../../Types';
import 'moment/locale/fr-ca';
import 'moment/locale/en-ca';

interface HoursOfOperationProps extends WithTranslation, WithDialogsProps {
  hoursOfOperations?: HoursOfOperation
  holidays: string | null
  onChange?: (hoursOfOperations: HoursOfOperation) => void
  mode?: string
  differentialUpdate?: boolean
  copyMode?:boolean
}

interface HoursOfOperationState {
  beginTime: Date
  endTime: Date
  hoursOfOperations: HoursOfOperation
  hoursOfOperationsSet: any
  selectedDates: any
}

let instances = 0;
class HoursOfOperationEdit extends React.Component<HoursOfOperationProps, HoursOfOperationState> {
  private originalData: HoursOfOperation;
  private idPrefix: string;

  constructor(props: HoursOfOperationProps) {
    super(props);
    this.originalData = JSON.parse(JSON.stringify(props.hoursOfOperations));
    this.state = {
      beginTime: new Date('2014-08-18T08:00:00'),
      endTime: new Date('2014-08-18T17:00:00'),
      hoursOfOperations: JSON.parse(JSON.stringify(props.hoursOfOperations)),
      selectedDates: {},
      hoursOfOperationsSet: {},
    };
    instances++;
    this.idPrefix = `id-${instances}`;
  }

  shouldComponentUpdate(nextProps: HoursOfOperationProps) {
    if (this.props.hoursOfOperations !== nextProps.hoursOfOperations) {
      const hoo : any = this.props.hoursOfOperations;
      this.setState({ hoursOfOperations: JSON.parse(JSON.stringify(nextProps.hoursOfOperations)) });
      const hooSet: any = this.state.hoursOfOperationsSet;
      const dates = getDates(this.props.holidays);
      dates.forEach((d) => {
        if (hoo[d.key] === null || hoo[d.key]) { hooSet[d.key] = true; }
      });
      this.setState({ selectedDates: {}, hoursOfOperationsSet: hooSet });
    }
    return true;
  }

  onDateCheck(e: React.ChangeEvent, value: boolean) {
    const sl = this.state.selectedDates;
    sl[e.target.id.replace(`${this.idPrefix}-`, '')] = value;
    this.setState({ selectedDates: sl });
  }

  createUntouchedHours(hoo: HoursOfOperation) {
    if (!this.props.differentialUpdate) return hoo;
    const res: HoursOfOperation = {};
    for (const day in this.state.hoursOfOperationsSet) {
      // @ts-ignore
      res[day] = hoo[day];
    }
    return res;
  }

  applyChanges() {
    const hoo: any = this.state.hoursOfOperations;
    const hooSet: any = this.state.hoursOfOperationsSet;
    const dates = getDates(this.props.holidays);
    const { t } = this.props;
    let counter = 0;
    const begin: string = moment(this.state.beginTime).format('HH:mm');
    const end: string = moment(this.state.endTime).format('HH:mm');

    if (begin.length !== 5 || end.length !== 5) {
      this.props.errorDialog(t('You must specify both (begin and end) hours.'), t('Please check the hour fields'));
      return;
    }

    dates.forEach((d) => {
      if (!this.state.selectedDates[d.key]) return;
      counter++;
      if (!hoo[d.key]) hoo[d.key] = {};
      hoo[d.key].begin = begin;
      hoo[d.key].end = end;
      hooSet[d.key] = true;
    });

    if (counter === 0) {
      this.props.errorDialog(t('You must select at least one day to set dates on.'), t('Please select at least one day'));
      return;
    }
    this.setState({ selectedDates: {}, hoursOfOperationsSet: hooSet });

    setTimeout(() => {
      this.props.onChange && this.props.onChange(this.createUntouchedHours(this.state.hoursOfOperations));
    });
  }

  resetChanges() {
    const hoursOfOperations = JSON.parse(JSON.stringify(this.originalData));
    this.setState({ hoursOfOperations, selectedDates: {}, hoursOfOperationsSet: {} });
    this.forceUpdate();
    setTimeout(() => {
      this.props.onChange && this.props.onChange(this.createUntouchedHours(this.state.hoursOfOperations));
    });
  }

  clearHours() {
    const hoo: any = this.state.hoursOfOperations;
    const hooSet: any = this.state.hoursOfOperationsSet;
    const dates = getDates(this.props.holidays);
    const { t } = this.props;
    let counter = 0;
    dates.forEach((d) => {
      if (!this.state.selectedDates[d.key]) return;
      counter++;
      hoo[d.key] = null;
      hooSet[d.key] = true;
    });
    if (counter === 0) {
      this.props.errorDialog(t('You must select at least one day to mark as closed.'), t('Please select at least one day'));
      return;
    }
    this.setState({ selectedDates: {}, hoursOfOperationsSet: hooSet });
    setTimeout(() => {
      this.props.onChange && this.props.onChange(this.createUntouchedHours(this.state.hoursOfOperations));
    });
  }

  render() {
    const { t } = this.props;
    moment.locale(this.props.i18n.language.replace('_', '-').toLowerCase());
    const dates = getDates(this.props.holidays);
    const hoo: any = this.state.hoursOfOperations;
    const closed = (
      <span style={{ color: this.props.differentialUpdate ? '#888' : '#999', fontStyle: 'italic' }}>
        {this.props.mode === 'contact' ? '-' : t('Closed')}
      </span>
    );
    const dontUpdate = <span style={{ color: '#BBB' }}>{t('(do not modify)')}</span>;

    return (
      <Grid container spacing={2} style={{ marginBottom: 20, textAlign: 'center', marginTop: -24 }}>
        <Grid item xs={6}>
          <KeyboardTimePicker
            margin="normal"
            okLabel={t('Ok')}
            cancelLabel={t('Cancel')}
            id={`${this.idPrefix}-begin-time-picker`}
            label={t('From')}
            value={this.state.beginTime}
            onChange={(date: any) => this.setState({ beginTime: date })}
            keyboardIcon={<WatchLater />}
            KeyboardButtonProps={{ 'aria-label': t('Change time') }}
            disabled={this.props.copyMode}
          />
        </Grid>
        <Grid item xs={6}>
          <KeyboardTimePicker
            margin="normal"
            id={`${this.idPrefix}-end-time-picker`}
            okLabel={t('Ok')}
            cancelLabel={t('Cancel')}
            label={t('To')}
            value={this.state.endTime}
            onChange={(date: any) => this.setState({ endTime: date })}
            keyboardIcon={<WatchLater />}
            KeyboardButtonProps={{ 'aria-label': t('Change time') }}
            disabled={this.props.copyMode}
          />
        </Grid>
        <Grid xs={4} item>
          <Button
            style={{ zoom: 0.8, width: '100%', minHeight: 50 }}
            onClick={this.applyChanges.bind(this)}
            disabled={this.props.copyMode}
          >
            {t('Apply')}
          </Button>
        </Grid>
        <Grid xs={4} item>
          <Button
            style={{ zoom: 0.8, width: '100%', minHeight: 50 }}
            onClick={this.clearHours.bind(this)}
            disabled={this.props.copyMode}
          >
            {this.props.mode === 'contact' ? t('Clear Hrs') : t('Set Closed')}
          </Button>
        </Grid>
        <Grid xs={4} item>
          <Button
            style={{ zoom: 0.8, width: '100%', minHeight: 50 }}
            onClick={this.resetChanges.bind(this)}
            disabled={this.props.copyMode}
          >
            {t('Reset All')}
          </Button>
        </Grid>
        <Grid xs={12} item style={{ marginBottom: 5 }}>
          {this.props.mode === 'contact' ? t('Select days to apply selected work hours') : t('Select days to apply selected hours of operation')}
        </Grid>
        {dates.map((d) => (
          <Grid container key={d.key}>
            <Grid item xs={6}>
              <FormControlLabel
                style={{ textAlign: 'left', width: 175, margin: 0 }}
                control={(
                  <Checkbox
                    style={{
                      height: 10, width: 10, marginLeft: 20, marginRight: 10,
                    }}
                    id={`${this.idPrefix}-${d.key}`}
                    onChange={this.onDateCheck.bind(this)}
                    color="primary"
                    checked={this.state.selectedDates[d.key] || false}
                    disabled={this.props.copyMode}
                  />
                )}
                label={<span style={{ fontSize: '0.8em' }}>{t(d.label)}</span>}
              />
            </Grid>
            <Grid item xs={6}>
              {getTimeString(hoo[d.key])
                 || (hoo[d.key] === null && closed)
                 || (!this.props.differentialUpdate && closed)
                 || (hoo[d.key] === undefined && dontUpdate)}
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  }
}

const HoursOfOperationEditWithStuff = withTranslation()(withDialogs(HoursOfOperationEdit));

export {
  HoursOfOperationEditWithStuff as HoursOfOperationEdit,
};
